///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class StateStorageService {
    private readonly KEY_PREFIX = 'gtth_project_';
    private readonly sessionStorage: Storage;

    constructor() {
        this.sessionStorage = window.sessionStorage;
    }

    getProjectSessionId(projectId: number): string {
        return this.sessionStorage.getItem(this.KEY_PREFIX + projectId);
    }

    setProjectSessionId(projectId: number, sessionId: string) {
        this.sessionStorage.setItem(this.KEY_PREFIX + projectId, sessionId);
    }

    clearProjectSessionId(projectId: number) {
        this.sessionStorage.removeItem(this.KEY_PREFIX + projectId);
    }
}
